import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import LoadingScreen from '../common/LoadingScreen';
import { isStaffRole, landingPathForRole } from '../../lib/roleRouting';

export { STAFF_ROLES } from '../../lib/roleRouting';

/**
 * Garde de route pour l'espace « Gestion CDV » (/staff).
 * Ouvert aux roles operationnels, pas seulement aux admins : un animateur ou un
 * coordinateur y accede alors qu'il n'a rien a faire dans /admin.
 */
const StaffRoute = () => {
  const { user, profile, profileLoaded } = useAuthStore();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Tant que le profil n'est pas charge, le role est inconnu : on attend. Sans
  // cette garde, un rafraichissement de page renvoyait vers l'espace parent.
  if (!profileLoaded) {
    return <LoadingScreen />;
  }

  const role = (user.app_metadata?.role as string) || profile?.role;

  if (!isStaffRole(role)) {
    // On renvoie vers l'espace correspondant au role plutot que vers `/`, pour
    // eviter un aller-retour par la page d'accueil.
    return <Navigate to={landingPathForRole(role)} replace />;
  }

  return <Outlet />;
};

export default StaffRoute;
